export const bundleData: any = {
    ca: [
        // 真实数据
        {
            id: '7787680301210',
            type: 2, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            off: '',
            offTips: '',
            name: 'BLADE Robotic Lawn Mower',
            tag: 2,
            isEnd: false,
            img: '/media/blade/crowdfunding/pc/1.png',
            mobileImg: '/media/blade/crowdfunding/h5/1.png',
            include: ['BLADE Robotic Lawn Mower x 1'],
            delivery_date: 'Early May 2023',
            sale: 0,
            count: 40,
            discountPrice: 3199,
            originalPrice: 3699,
            price_suffix: '',
            sku: 'ZMH100-B-US-V20',
            node: 'product-component-1681782831809',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7787679416474',
            type: 2,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'BLADE Robotic Lawn Mower',
            tag: null,
            isEnd: false,
            img: '/media/blade/crowdfunding/pc/1.png',
            mobileImg: '/media/blade/crowdfunding/h5/1.png',
            include: ['BLADE Robotic Lawn Mower x 1'],
            delivery_date: 'Early May 2023',
            sale: 0,
            count: null,
            discountPrice: 3699,
            originalPrice: 3699,
            price_suffix: '',
            sku: 'ZMH100-B-US-V20',
            node: 'product-component-1681782794499',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // BLADE Robotic Lawn Mower + Lawn Sweeper Kit
        {
            id: '7787680858266',
            type: 2, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'BLADE Robotic Lawn Mower + Lawn Sweeper Kit',
            tag: 2,
            isEnd: false,
            img: '/media/blade/crowdfunding/pc/2.png',
            mobileImg: '/media/blade/crowdfunding/h5/2.png',
            include: ['BLADE Robotic Lawn Mower x 1', 'Lawn Sweeper Kit x 1'],
            delivery_date: 'Early June 2023',
            sale: 0,
            count: 20,
            discountPrice: 3699,
            originalPrice: 4599,
            price_suffix: '',
            sku: 'BLADE-KIT',
            node: 'product-component-1681782749889',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '7787680628890',
            type: 2,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'BLADE Robotic Lawn Mower + Lawn Sweeper Kit',
            tag: null,
            isEnd: false,
            img: '/media/blade/crowdfunding/pc/2.png',
            mobileImg: '/media/blade/crowdfunding/h5/2.png',
            include: ['BLADE Robotic Lawn Mower x 1', 'Lawn Sweeper Kit x 1'],
            delivery_date: 'Early June 2023',
            sale: 0,
            count: null,
            discountPrice: 3999,
            originalPrice: 4599,
            price_suffix: '',
            sku: 'BLADE-KIT',
            node: 'product-component-1681782686932',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
    ],
    us: [
        // 真实数据
        {
            id: '6900748714057',
            type: 2, //1 时间限定 2 数量限定
            stage: 1, // 1 早鸟 2 原价
            off: '',
            offTips: '',
            name: 'BLADE Robotic Lawn Mower',
            tag: 2,
            isEnd: false,
            img: '/media/blade/crowdfunding/pc/1.png',
            mobileImg: '/media/blade/crowdfunding/h5/1.png',
            include: ['BLADE Robotic Lawn Mower x 1'],
            delivery_date: '',
            sale: 0,
            count: 200,
            discountPrice: 2599,
            originalPrice: 2899,
            price_suffix: '',
            sku: 'ZMH100-B-US-V20',
            node: 'product-component-1681195220801',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '6900748582985',
            type: 2,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'BLADE Robotic Lawn Mower',
            tag: null,
            isEnd: false,
            img: '/media/blade/crowdfunding/pc/1.png',
            mobileImg: '/media/blade/crowdfunding/h5/1.png',
            include: ['BLADE Robotic Lawn Mower x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 2899,
            originalPrice: 2899,
            price_suffix: '',
            sku: 'BLADE-KIT',
            node: 'product-component-1681195118853',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },

        // // BLADE Robotic Lawn Mower + Lawn Sweeper Kit // 売り切れのため, 2023年5月４日の夜でSweeper Kitに切り替え
        // {
        //     id: '6900748681289',
        //     type: 2, //1 时间限定 2 数量限定
        //     stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     off: '',
        //     offTips: '',
        //     name: 'BLADE Robotic Lawn Mower + Lawn Sweeper Kit',
        //     tag: 2,
        //     isEnd: false,
        //     img: '/media/blade/crowdfunding/pc/2.png',
        //     mobileImg: '/media/blade/crowdfunding/h5/2.png',
        //     include: ['BLADE Robotic Lawn Mower x 1', 'Lawn Sweeper Kit x 1'],
        //     delivery_date: '',
        //     sale: 0,
        //     count: 100,
        //     discountPrice: 2999,
        //     originalPrice: 3599,
        //     price_suffix: '',
        //     sku: 'BLADE-KIT',
        //     node: 'product-component-1681195562635',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        // },
        // {
        //     id: '6900748746825',
        //     type: 2,
        //     stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
        //     off: '',
        //     offTips: '',
        //     name: 'BLADE Robotic Lawn Mower + Lawn Sweeper Kit',
        //     tag: null,
        //     isEnd: false,
        //     img: '/media/blade/crowdfunding/pc/2.png',
        //     mobileImg: '/media/blade/crowdfunding/h5/2.png',
        //     include: ['BLADE Robotic Lawn Mower x 1', 'Lawn Sweeper Kit x 1'],
        //     delivery_date: '',
        //     sale: 0,
        //     count: null,
        //     discountPrice: 3199,
        //     originalPrice: 3599,
        //     price_suffix: '',
        //     sku: 'BLADE-KIT',
        //     node: 'product-component-1681195506243',
        //     buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        // },
        // BLADE Robotic Lawn Mower + Lawn Sweeper Kitが売り切れのため, 2023年5月４日の夜で下のSweeper Kitに切り替え
        {
            id: '6904497012809',
            type: 2, //1 时间限定 2 数量限定
            stage: 1, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow BLADE Lawn Sweeper Kit',
            tag: 2,
            isEnd: false,
            img: '/media/blade/crowdfunding/pc/3.png',
            mobileImg: '/media/blade/crowdfunding/h5/3.png',
            include: ['Lawn Sweeper Kit x 1'],
            delivery_date: '',
            sale: 0,
            count: 100,
            discountPrice: 600,
            originalPrice: 699,
            price_suffix: '',
            sku: 'BLADE-KIT',
            node: 'product-component-1681782686932',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-extra-battery-bundle-super-early-bird',
        },
        {
            id: '6904498028617',
            type: 2,
            stage: 2, // 1 第一个倒计时阶段 2 第二个倒计时阶段
            off: '',
            offTips: '',
            name: 'EcoFlow BLADE Lawn Sweeper Kit',
            tag: null,
            isEnd: false,
            img: '/media/blade/crowdfunding/pc/3.png',
            mobileImg: '/media/blade/crowdfunding/h5/3.png',
            include: ['Lawn Sweeper Kit x 1'],
            delivery_date: '',
            sale: 0,
            count: null,
            discountPrice: 699,
            originalPrice: 699,
            price_suffix: '',
            sku: 'BLADE-KIT',
            node: 'product-component-1683192174948',
            buyLink: 'https://jp.ecoflow.com/products/wave-2-portable-air-conditioner-super-early-bird',
        },
    ],
};
